// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-5027b202]{padding-bottom:35px;min-height:100vh}", ""]);
// Exports
module.exports = exports;
